import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type AssetVersionNumber_AudioAsset_Fragment = { __typename?: 'AudioAsset', id: string, versionNumber?: number | null };

export type AssetVersionNumber_DocumentAsset_Fragment = { __typename?: 'DocumentAsset', id: string, versionNumber?: number | null };

export type AssetVersionNumber_FileAsset_Fragment = { __typename?: 'FileAsset', id: string, versionNumber?: number | null };

export type AssetVersionNumber_FolderAsset_Fragment = { __typename?: 'FolderAsset', id: string, versionNumber?: number | null };

export type AssetVersionNumber_ImageAsset_Fragment = { __typename?: 'ImageAsset', id: string, versionNumber?: number | null };

export type AssetVersionNumber_InteractiveAsset_Fragment = { __typename?: 'InteractiveAsset', id: string, versionNumber?: number | null };

export type AssetVersionNumber_InteractiveLiveAsset_Fragment = { __typename?: 'InteractiveLiveAsset', id: string, versionNumber?: number | null };

export type AssetVersionNumber_ModelAsset_Fragment = { __typename?: 'ModelAsset', id: string, versionNumber?: number | null };

export type AssetVersionNumber_UnsupportedAsset_Fragment = { __typename?: 'UnsupportedAsset', id: string, versionNumber?: number | null };

export type AssetVersionNumber_VersionStackAsset_Fragment = { __typename?: 'VersionStackAsset', id: string, versionNumber?: number | null };

export type AssetVersionNumber_VideoAsset_Fragment = { __typename?: 'VideoAsset', id: string, versionNumber?: number | null };

export type AssetVersionNumberFragment = AssetVersionNumber_AudioAsset_Fragment | AssetVersionNumber_DocumentAsset_Fragment | AssetVersionNumber_FileAsset_Fragment | AssetVersionNumber_FolderAsset_Fragment | AssetVersionNumber_ImageAsset_Fragment | AssetVersionNumber_InteractiveAsset_Fragment | AssetVersionNumber_InteractiveLiveAsset_Fragment | AssetVersionNumber_ModelAsset_Fragment | AssetVersionNumber_UnsupportedAsset_Fragment | AssetVersionNumber_VersionStackAsset_Fragment | AssetVersionNumber_VideoAsset_Fragment;

export const AssetVersionNumber = /*#__PURE__*/ gql`
    fragment AssetVersionNumber on Asset {
  id
  versionNumber
}
    ` as unknown as DocumentNode<AssetVersionNumberFragment, unknown>;

        

        
export const useAssetVersionNumberFragment = (
  input: string | Omit<UseFragmentOptions<AssetVersionNumberFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Asset' } };
    return input;
  })();

  return useFragment<AssetVersionNumberFragment>({
    fragment: AssetVersionNumber,
    fragmentName: 'AssetVersionNumber',
    ...options,
  });
};
  
        